module.exports = __webpack_public_path__ + "static/media/cms-icon-empty-files.058fb1a2.svg";